<template>
    <ModalMask :opacity="1" :close-trigger="closeTrigger" :closing="closing" :customClass="customClass" @mount="mount">
        <div ref="refModal" class="Modal" :class="modalClass" tabindex="-1" role="dialog">
            <button type="button"
                class="absolute top-2  right-2 leading-none text-gray-700 opacity-50 border-0 bg-transparent text-xl"
                aria-label="Close" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style="width: 25px; height: 25px;">
                    <path
                        d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" />
                </svg>
                <svg class="d-none" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40.5 40.3774H0.5V0.498487H40.5V40.3774Z" fill="white" />
                    <path d="M1 0.996973V39.8789H40V0.996973H1ZM0 0H41V40.8759H0V0Z" fill="#FF00A7" />
                    <path d="M9.90588 30.9999L31.0929 9.877" stroke="#FF00A7" stroke-width="2" />
                    <path d="M9.90588 9.877L31.0929 30.9999" stroke="#FF00A7" stroke-width="2" />
                </svg>

            </button>
            <slot></slot>
        </div>
    </ModalMask>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';

.ModalMask {
    padding: 1.5rem;
}

.Modal {
    margin-left: auto;
    margin-right: auto;
    border-radius: 20px;
    box-shadow: 0px 6px 20px 10px rgba(0, 0, 0, 0.08);
    padding: 40px 0;
    position: relative;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-clip: padding-box;
    outline: 0;
    transform: scale(1);
    transition: transform ease-out 0.3s;

    @media (min-width: @screen-sm-min) {
        margin: 30px auto;
    }
}

/*.Modal__close {*/
/*    position: absolute;*/
/*    top: 2px;*/
/*    right: 5px;*/
/*    opacity: 0.4;*/
/*    border: 0;*/
/*    background-color: transparent;*/
/*    font-size: 24px;*/
/*}*/

.ModalMask {
    &.modal-enter-active:not(.--restored) {
        .Modal {
            transform: scale(0.3);
            transition: transform ease-in 0.1s;
        }

        &.modal-enter-to .Modal {
            transform: scale(1);
        }
    }
}
</style>

<script type="text/babel">
import { ReplaySubject } from 'rxjs'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import { delay } from 'rxjs/operators'
import HasEventListeners from 'dashboard-js/mixins/HasEventListeners'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ModalMask from 'dashboard-js/components/ModalMask'
import TinyGesture from 'tinygesture'

export default {
    components: {
        ModalMask,
    },

    mixins: [HasEventListeners, HasSubscriptions],
    props: {
        gestures: {
            default: true,
        },
        size: {
            default: 'lg',
        },
        customClass : {
            default: ''
        }
    },

    data() {
        return {
            closeTrigger: new ReplaySubject(1),
            closing: new ReplaySubject(1),

            maskEl: null,
            modalEl: null,
            resolvedModalClass: '',
            gesture: null,
            pendingClose: false,
        }
    },

    computed: {
        modalClass() {
            // Used values: w-md w-lg
            return this.resolvedModalClass + ' w-' + this.size
        },

        maskOpacity() {
            return this.pendingClose ? 0.1 : 0.5
        },
    },

    created() {
        this.subscribe(this.closeTrigger.pipe(delay(300)), () => this.$emit('close'))
    },

    beforeDestroy() {
        this.closing.next()
        this.gesture.destroy()

        clearAllBodyScrollLocks()
    },

    methods: {
        mount(maskEl) {
            this.maskEl = maskEl
            this.modalEl = this.$refs.refModal
            this.resolvedModalClass = this.$el.className.replace('vue-portal', '')
            this.gesture = new TinyGesture(maskEl, { mouseSupport: false })

            if (this.gestures) {
                this.listenTouch()
            }

            disableBodyScroll(maskEl, { reserveScrollBarGap: true })

            this.$emit('mounted')
        },

        close() {
            this.closeTrigger.next()
        },

        getDirection() {
            return this.gesture.velocityY > 0 ? 'up' : 'down'
        },

        listenTouch() {
            let scrollTopOnStartInterval = null

            this.gesture.on('panmove', () => {
                if (!this.gesture.animationFrame) {
                    const direction = this.getDirection()
                    let scrollTopOnStart = this.maskEl.scrollTop
                    scrollTopOnStartInterval = setInterval(
                        () => (scrollTopOnStart = this.maskEl.scrollTop),
                        200
                    )

                    const animate = () => {
                        let pendingClose = false

                        if (
                            !this.gesture.swipingDirection.startsWith('pre-') &&
                            Math.abs(this.gesture.touchMoveY) > 150
                        ) {
                            if (this.reachedTop(scrollTopOnStart) && direction === 'up') {
                                pendingClose = 'up'
                                this.modalEl.style.transform = 'scale(0.9)'
                            } else if (
                                this.reachedBottom(scrollTopOnStart) &&
                                direction === 'down'
                            ) {
                                pendingClose = 'down'
                                this.modalEl.style.transform = 'scale(0.9)'
                            }
                        }

                        if (!pendingClose) {
                            this.modalEl.style.transform = 'scale(1)'
                        }

                        this.pendingClose = pendingClose
                        this.gesture.animationFrame = requestAnimationFrame(animate)
                    }

                    this.gesture.animationFrame = requestAnimationFrame(animate)
                }
            })

            this.gesture.on('panend', () => {
                cancelAnimationFrame(this.gesture.animationFrame)
                clearInterval(scrollTopOnStartInterval)

                this.gesture.animationFrame = null

                if (this.pendingClose) {
                    const offset = this.gesture.touchMoveY > 0 ? 1000 : -1000
                    this.modalEl.style.transform = 'translateY(' + offset + 'px) scale(0.9)'
                    this.close()
                }
            })
        },

        reachedBottom(scrollY) {
            return this.maskEl.clientHeight + scrollY >= this.maskEl.scrollHeight
        },

        reachedTop(scrollY) {
            return scrollY <= 0
        },
    },
}
</script>
